module.exports = __webpack_public_path__ + "assets/img/three.9bf9e243.png";